import { MEventTarget } from "../types";

type NavParams = {
  selector: string;
  mobileSelector?: string;
  drawerSelector?: string;
  toggleSelector?: string;
}

export default class Nav {
  navbar: Element | null;
  mobileNav: Element | null | undefined;
  drawer: Element | null | undefined;
  params: NavParams;

  constructor(params: NavParams) {
    this.params = params;
    
    const {
      selector,
      mobileSelector = '.mobile-navigation',
    } = this.params;

    this.delegateHandler = this.delegateHandler.bind(this);

    this.navbar = document.querySelector(selector);
    this.mobileNav = this.navbar?.querySelector(mobileSelector);
    this.init();
  }

  init() {
    if (window.outerWidth <= 820) {
      const {
        drawerSelector = '.drawer-wrap',
      } = this.params;
      this.drawer = this.navbar?.querySelector(drawerSelector);
      
      if (this.navbar) {
        this.navbar.addEventListener('click', this.delegateHandler);
      }
    }
  }

  delegateHandler(e: Event) {
    const target = e.target as MEventTarget;

    if (target && target.matches) {
      if (target.matches('.menu-toggle') || target.matches('a')) {
        this.toggleMobileNav();
      }
    }
  }

  toggleMobileNav() {
    this.drawer?.classList.toggle('is-open');
  }
}
